import type { InventoryOrder } from '~/api/graphql/generated/types'

import { OrderItemsPageHeaderLabels } from './order-items/OrderItemsPageHeaderLabels'
import { getReceivedBy } from './utils'

interface OrderCardProps {
  inventoryOrder: InventoryOrder
  readOnly?: boolean
}

export const OrderCard = ({ inventoryOrder, readOnly }: OrderCardProps) => {
  const receivedBy = getReceivedBy(inventoryOrder)

  return (
    <OrderItemsPageHeaderLabels
      inventoryOrder={inventoryOrder}
      readOnly={readOnly}
      receivedBy={receivedBy}
    />
  )
}
